﻿import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ListItem,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import HelpIcon from "@mui/icons-material/Help";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import "../Addtimesheet.css";
import {
  DELETE_TIMESHEETS,
  DELETE_TIMESHEETS_ENTRIES,
  FETCH_TIMESHEET_ENTRIES,
  FETCH_TIMESHEETS_GOALS,
  SAVE_TIMEHSEET_GOALS,
  SAVE_TIMESHEETS,
  SAVE_TIMESHEETS_ENTRIES,
  SAVE_TIMESHEETS_PICTURES,
  USER_TIMESHEETS_CLOCK_IN_CLOCK_OUT
} from "../../../constant/Apipath";
import { Fileuploadrequestcall } from "../../../request/Fileuploadrequest";
import { Postrequestcall } from "../../../request/Postrequest";
import moment from "moment";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import { getFormattedAddress } from "../../common/GetFormattedAddress";
import { setShowalert } from "../../../redux/actions/actions";
import { useDispatch } from "react-redux";
import ImageIcon from "@mui/icons-material/Image";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";
import PromptModal from "../../common/PromptModal";
import Joblist from "../Joblist";
import dayjs from "dayjs";
import PlaceholderImg from "../../../assets/images/placeholder_img.jpg";

// ✅ Import utility functions
import {
  convertToDecimal,
  calculateTotalHours,
  base64ToFile,
  fileToBase64,
  formatNumericToTime
} from "./../utils/timesheetUtils";

const AddClockIn = ({
  open,
  onClose,
  seletetdClockInTimesheet,
  operation,
  selectedClockInJob,
  setSelectedClokInJob,
  loginData,
  goallist,
  isSmallScreen,
  onSaveComplete,
  onDeleteComplete,
  onGoalModalOpen,
  onJoblistOpen
}) => {
  const dispatch = useDispatch();

  // ✅ FIXED: Separate loading states for different operations
  const [showJoblist, setShowJoblist] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // ✅ ADD SEPARATE DELETE LOADING
  const [isSavingClock, setIsSavingClockIN] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [roleIndex, setRoleIndex] = useState(1);
  const [totalTimeForClock, setTotalTimeForClock] = useState("00:00");
  const [totalDistanceForClockIn, setTotalDistanceForClockIn] = useState(0);
  const [deletedEntries, setDeletedEntries] = useState([]);
  const [deletedGoalsCategories, setDeletedGoalsCategories] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState();
  const [goalIndex, setGoalIndex] = useState(0);
  const [indexForGoal, setIndexForGoal] = useState(0);
  const [selectedJob, setSelectedJob] = useState([]);
  const [confirmSwitchClock, setConfirmSwitchClock] = useState({
    show: false,
    newIndex: null,
    prevIndex: null
  });

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_ADD_CLOCKIN = English.TimeSheet.TEXT_ADD_CLOCKIN,
    TEXT_EDIT_CLOCKIN = English.TimeSheet.TEXT_EDIT_CLOCKIN,
    TEXT_TOTAL_CAPS = English.TimeSheet.TEXT_TOTAL_CAPS,
    TEXT_KM = English.TimeSheet.TEXT_KM,
    TEXT_MI = English.TimeSheet.TEXT_MI,
    TEXT_TIMESHEET_DATE = English.TimeSheet.TEXT_TIMESHEET_DATE,
    BUTTON_ADD_JOB = English.TimeSheet.BUTTON_ADD_JOB,
    TEXT_JOB_START = English.TimeSheet.TEXT_JOB_START,
    TEXT_ADD_GOAL = English.TimeSheet.TEXT_ADD_GOAL,
    TEXT_COMMENTS_PLACEHOLDER = English.TimeSheet.TEXT_COMMENTS_PLACEHOLDER,
    TEXT_ADD_PICTURES = English.TimeSheet.TEXT_ADD_PICTURES,
    TEXT_NO_COMPANY = English.TimeSheet.TEXT_NO_COMPANY,
    TEXT_IN = English.TimeSheet.TEXT_IN,
    TEXT_CLOCK_IN = English.TimeSheet.TEXT_CLOCK_IN,
    TEXT_OUT = English.TimeSheet.TEXT_OUT,
    TEXT_CLOCK_OUT = English.TimeSheet.TEXT_CLOCK_OUT,
    TEXT_MILAGE = English.TimeSheet.TEXT_MILAGE,
    TEXT_GOAL_CREDIT_WARNING = English.TimeSheet.TEXT_GOAL_CREDIT_WARNING,
    TEXT_DELETE_TIMESHEET_TITLE = English.TimeSheet.TEXT_DELETE_TIMESHEET_TITLE,
    TEXT_DELETE_TIMESHEET_DESCRIPTION = English.TimeSheet.TEXT_DELETE_TIMESHEET_DESCRIPTION,
    BUTTON_DELETE = English.TimeSheet.BUTTON_DELETE
  } = LanguageData || {};

  const labelArray = [
    { key: 1, value: TEXT_KM },
    { key: 2, value: TEXT_MI }
  ];

  // ✅ FIXED: Check if any operation is in progress
  const isAnyOperationInProgress = isSaving || isDeleting || isSavingClock || loading;

  // Fetch timesheet data
  const onTimesheetclick = async () => {
    setIsLoading(true);
    try {
      // Fetch goals for the selected timesheet
      const sendObj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        SearchList: [{ TimesheetId: seletetdClockInTimesheet?.id }]
      };
      const getTimesheetGoals = await Postrequestcall(
        FETCH_TIMESHEETS_GOALS,
        sendObj,
        loginData?.accessToken
      );

      // Fetch entries for the selected timesheet
      const sendEnObj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ TimesheetId: seletetdClockInTimesheet?.id }]
      };
      const fetchResponse = await Postrequestcall(
        FETCH_TIMESHEET_ENTRIES,
        sendEnObj,
        loginData?.accessToken
      );

      const timesheetsEntries = fetchResponse?.data?.data || [];

      // Calculate total distance and total hours
      const totalDistance = timesheetsEntries?.reduce(
        (total, item) => total + Number(item.distance || 0),
        0
      );

      const parseToMinutes = (val) => {
        if (!val) return 0;
        if (typeof val === "string" && val.includes(":")) {
          const [h, m] = val.split(":").map(Number);
          return h * 60 + m;
        }
        const num = parseFloat(val);
        if (!isNaN(num)) return Math.round(num * 60);
        return 0;
      };

      const totalMinutes = timesheetsEntries?.reduce((total, item) => {
        if (item.calculateHours && item.calculateHours !== "00:00") {
          return total + parseToMinutes(item.calculateHours);
        } else if (item.hours && item.hours !== 0) {
          return total + Math.round(Number(item.hours) * 60);
        }
        return total;
      }, 0);

      const totalTimes =
        totalMinutes > 0
          ? Math.floor(totalMinutes / 60) + ":" + (totalMinutes % 60).toString().padStart(2, "0")
          : "00:00";

      // Map goals to each entry
      const newTimeSheetData = timesheetsEntries?.map((entry) => {
        const entryWithGoals = { ...entry, timesheetGoalsArray: [] };
        getTimesheetGoals?.data?.data?.forEach((goal) => {
          if (goal.timeSheetEntryId === entry.id) {
            entryWithGoals.timesheetGoalsArray.push({
              id: goal.id,
              key: goal.goalId,
              value: goal.goalName,
              goalName: goal.goalName,
              categoryName: goal.goalCategoryName,
              categoryId: goal.categoryId,
              time: goal.hours,
              goalId: goal.goalId,
              siteId: goal.siteId,
              siteName: goal.siteName,
              timeSheetEntryId: goal.timeSheetEntryId,
              timeSheetId: goal.timeSheetId
            });
          }
        });
        return entryWithGoals;
      });

      // Set all data in state
      setSelectedClokInJob(newTimeSheetData);
      setTotalDistanceForClockIn(totalDistance);
      setTotalTimeForClock(totalTimes ? totalTimes : "00:00");
    } catch (error) {
      console.error("onTimesheetclick-> Error While Fetching Timesheet Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (seletetdClockInTimesheet && seletetdClockInTimesheet.id) {
      onTimesheetclick();
    }
  }, [seletetdClockInTimesheet]);

  const TimesheetClockInclose = () => {
    setSelectedClokInJob([]);
    setTotalDistanceForClockIn(0);
    setTotalTimeForClock("00:00");
    onClose();
  };

  const selectedLabel = labelArray.find((label) => label.key === roleIndex)?.value || "N/A";

  const calculateDecimalHours = (startTime, endTime) => {
    if (!startTime || !endTime) return 0;
    const [startH, startM] = startTime.split(":").map(Number);
    const [endH, endM] = endTime.split(":").map(Number);
    const start = startH * 60 + startM;
    const end = endH * 60 + endM;
    const diffMinutes = end - start;
    if (diffMinutes <= 0) return 0;
    return parseFloat((diffMinutes / 60).toFixed(2));
  };

  const formattedTime = String(totalTimeForClock).split(":").join(".");

  const onSaveTimesheet = async () => {
    setIsSaving(true);
    try {
      const calculateTotalMinutes = (timeStr) => {
        const [hrs, mins] = timeStr.split(":").map(Number);
        return hrs * 60 + mins;
      };

      const totalMinutes = selectedClockInJob?.reduce((total, item) => {
        if (item.calculateHours) {
          total += calculateTotalMinutes(item.calculateHours);
        }
        return total;
      }, 0);

      const formatMinutesToHHdotMM = (totalMinutes) => {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const hh = String(hours).padStart(2, "0");
        const mm = String(minutes).padStart(2, "0");
        return `${hh}.${mm}`;
      };

      const totalTimeForClock2 = formatMinutesToHHdotMM(totalMinutes);
      setTotalTimeForClock(totalTimeForClock2);

      const totalDistanceForClockIn2 = selectedClockInJob.reduce((total, item) => {
        total += Number(item.distance || 0);
        return total;
      }, 0);

      const timesheetObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: seletetdClockInTimesheet?.id || selectedClockInJob[0]?.timesheetId,
            TimesheetDate: dayjs().format("YYYY-MM-DD"),
            TotalHours: formattedTime,
            TotalDistance: totalDistanceForClockIn2,
            UnitOfDistance: selectedLabel,
            IsSent: false,
            ModifiedBy: loginData?.userInformation?.UserId,
            TimesheetTypeId: 2,
            TimesheetStatus: 1
          }
        ]
      };

      const timesheetData = await Postrequestcall(
        SAVE_TIMESHEETS,
        timesheetObj,
        loginData?.accessToken
      );

      if (!timesheetData?.data?.data?.length) {
        throw new Error("Timesheet save failed.");
      }

      // Prepare Entries
      const finalEntriesData = selectedClockInJob?.map((job) => {
        const calculatedHours = calculateDecimalHours(job.clockInTime, job.clockOutTime);
        return {
          Id: job.id,
          TimesheetId: timesheetData.data.data[0].objData.id,
          SiteId: job.siteId,
          Hours: calculatedHours,
          Distance: job.distance || 0,
          UnitOfDistance: job.unitOfDistance === "km" ? "km" : "mi",
          Comments: job.comments,
          CompanyId: job.companyId,
          ModifiedBy: loginData?.userInformation?.UserId,
          ProjectId: job.projectId,
          ClockInTime: job?.clockInTime,
          ClockOutTime: job?.clockOutTime
        };
      });

      const finalEntriesObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: finalEntriesData
      };

      const savedEntry = await Postrequestcall(
        SAVE_TIMESHEETS_ENTRIES,
        finalEntriesObj,
        loginData?.accessToken
      );

      // Save Goals
      const goalsSavePromises = selectedClockInJob.flatMap(
        (job) =>
          job.timesheetGoalsArray?.map((goal) => {
            let hoursFormatted = "00.00";

            if (typeof goal.time === "string") {
              if (goal.time.includes(":")) {
                const [h, m] = goal.time.split(":").map(Number);
                hoursFormatted = (h + m / 60).toFixed(2);
              } else if (goal.time.includes(".")) {
                hoursFormatted = parseFloat(goal.time).toFixed(2);
              }
            } else if (typeof goal.time === "number") {
              hoursFormatted = goal.time.toFixed(2);
            }

            const saveGoalsDetailsObj = {
              UserId: loginData?.userInformation?.UserId,
              ReturnRecordId: true,
              ReturnRecordError: true,
              SaveList: [
                {
                  Id: goal.id || 0,
                  TimeSheetId: timesheetData.data.data[0].objData.id,
                  TimeSheetEntryId: savedEntry?.data?.data?.find(
                    (entry) => entry.objData?.comments.toLowerCase() === job.comments.toLowerCase()
                  )?.objData?.id,
                  SiteId: job.siteId,
                  GoalId: goal.goalId,
                  goalCategoryId: goal.categoryId || 0,
                  Hours: hoursFormatted,
                  ModifiedBy: loginData?.userInformation?.UserId,
                  ProjectId: job.projectId
                }
              ]
            };

            return Postrequestcall(
              SAVE_TIMEHSEET_GOALS,
              saveGoalsDetailsObj,
              loginData?.accessToken
            );
          }) || []
      );

      if (goalsSavePromises.length > 0) {
        await Promise.all(goalsSavePromises);
      }

      // Save images
      for (let job of selectedClockInJob) {
        const newPictures = job.pictureList?.filter((picture) => picture.url) || [];
        for (let picture of newPictures) {
          const file = base64ToFile(picture.url, "image.png", "image/png");
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("TimeSheetId", timesheetData.data.data[0].objData.id);
          formData.append(
            "TimeSheetEntryId",
            savedEntry?.data?.data?.find(
              (entry) => entry.objData?.comments.toLowerCase() === job.comments.toLowerCase()
            )?.objData?.id
          );
          formData.append("SiteId", job.siteId);
          formData.append("ProjectId", job.userSiteProjectId || job.projectId);
          formData.append("ModifiedBy", loginData?.userInformation?.UserId);
          formData.append("PictureUrl", file);

          await Fileuploadrequestcall(SAVE_TIMESHEETS_PICTURES, formData, loginData?.accessToken);
        }
      }

      // Notify parent component of successful save
      if (onSaveComplete) {
        await onSaveComplete();
      }

      TimesheetClockInclose();
    } catch (error) {
      console.error("onSaveTimesheet-> Error When Saving Timesheet: ", error);
    } finally {
      setIsSaving(false);
    }
  };

  const updatedJobs = selectedClockInJob?.map((job) => ({
    ...job,
    hours: calculateTotalHours(job.clockInTime, job.clockOutTime)
  }));

  selectedClockInJob?.splice(0, selectedClockInJob.length, ...updatedJobs);

  const handleChooseFile = async (e, index) => {
    const files = Array.from(e.target.files);
    const base64Images = await Promise.all(
      files.map(async (file) => ({
        url: await fileToBase64(file)
      }))
    );

    let data = [...selectedClockInJob];
    if (!data[index].pictureList) {
      data[index].pictureList = [];
    }
    data[index].pictureList = [...data[index].pictureList, ...base64Images];
    setSelectedClokInJob(data);
  };

  const onDeletePicturePressed = (picItem, picIndex, entiresDataIndex) => {
    const remaningPictureList = selectedClockInJob[entiresDataIndex]?.pictureList?.filter(
      (pic, i) => i !== picIndex
    );
    let data = [...selectedClockInJob];
    data[entiresDataIndex].pictureList = remaningPictureList ?? [];
    setSelectedClokInJob(data ?? []);
  };

  const openImage = (parentIndex) => {
    setSelectedClokInJob((prevJobs) =>
      prevJobs.map((item, index) => ({
        ...item,
        isShowimage: parentIndex === index ? !item.isShowimage : false
      }))
    );
    setIndexForGoal(parentIndex);
  };

  const recalculateTotals = useCallback((jobs) => {
  if (!jobs || jobs.length === 0) {
    setTotalTimeForClock("00:00");
    setTotalDistanceForClockIn(0);
    return;
  }
  
  // ✅ FIXED: Calculate total decimal hours from clockIn/clockOut times
  const totalDecimalHours = jobs.reduce((sum, job) => {
    if (job.clockInTime && job.clockOutTime && 
        job.clockInTime !== "00:00" && job.clockOutTime !== "00:00") {
      // Use the existing calculateDecimalHours function
      const decimalHours = calculateDecimalHours(job.clockInTime, job.clockOutTime);
      return sum + decimalHours;
    }
    return sum;
  }, 0);
  
  console.log('totalDecimalHours', totalDecimalHours);
  
  // Convert decimal hours back to HH:MM format
  const totalHours = Math.floor(totalDecimalHours);
  const totalMinutes = Math.round((totalDecimalHours - totalHours) * 60);
  const totalTimeStr = `${totalHours.toString().padStart(2, "0")}:${totalMinutes.toString().padStart(2, "0")}`;
  
  setTotalTimeForClock(totalTimeStr);
  
  // Calculate total distance
  const totalDist = jobs.reduce((sum, job) => sum + (Number(job.distance) || 0), 0);
  setTotalDistanceForClockIn(totalDist);
}, []);

  const removeCurrentTimesheet = async (item, index) => {
    try {
      const userId = loginData?.userInformation?.UserId;
      const deleteEntriesPayload = {
        UserId: userId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [{ Id: item.id }]
      };

      await Postrequestcall(
        DELETE_TIMESHEETS_ENTRIES,
        deleteEntriesPayload,
        loginData?.accessToken
      );

      // Remove the entry from state
      const updatedEntries = selectedClockInJob.filter((entry, i) => i !== index);
      setSelectedClokInJob(updatedEntries);

      // Recalculate totals
      recalculateTotals(updatedEntries);
      // let updatedTotalDistance = 0;
      // if (updatedEntries.length > 0) {
      //   updatedTotalDistance = updatedEntries.reduce(
      //     (sum, entry) => sum + Number(entry.distance || 0),
      //     0
      //   );
      // }
      // setTotalDistanceForClockIn(updatedTotalDistance);
    } catch (err) {
      console.error("Failed to delete timesheet entry:", err);
    }
  };

  const calculateHoursBetween = (startTime, endTime) => {
    try {
      if (startTime === "00:00" || endTime === "00:00") {
        return "0";
      }
      const [startHour, startMin] = startTime.split(":").map(Number);
      const [endHour, endMin] = endTime.split(":").map(Number);
      let startMinutes = startHour * 60 + startMin;
      let endMinutes = endHour * 60 + endMin;
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60;
      }
      const diffMinutes = endMinutes - startMinutes;
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;
      return `${hours.toString().padStart(2, "0")}.${minutes.toString().padStart(2, "0")}`;
    } catch (error) {
      console.log("ERROR : [ calculateHoursBetween ] >", error);
      return "0";
    }
  };

  const updateClockInAndClockOutTime = async (item, index, type, prevIndex) => {
    try {
      setIsSavingClockIN(true);
      const now = moment().format("HH:mm");
      const isClockingIn = type === "in";
      const updatedClockIn = isClockingIn ? now : item?.clockInTime;
      const updatedClockOut = isClockingIn ? "00:00" : now;

      const saveList = [
        {
          Id: item?.id || 0,
          ClockInTime: updatedClockIn,
          ClockOutTime: updatedClockOut,
          Comments: item?.comments || "",
          ModifiedBy: loginData?.userInformation?.UserId || 1
        }
      ];

      if (typeof prevIndex === "number" && selectedClockInJob[prevIndex]) {
        const prevItem = selectedClockInJob[prevIndex];
        saveList.push({
          Id: prevItem?.id || 0,
          ClockInTime: prevItem?.clockInTime,
          ClockOutTime: now,
          Comments: prevItem?.comments || "",
          ModifiedBy: loginData?.userInformation?.UserId || 1
        });
      }

      const clockInOutPayload = {
        UserId: loginData?.userInformation?.UserId || 1,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: saveList
      };

      await Postrequestcall(
        USER_TIMESHEETS_CLOCK_IN_CLOCK_OUT,
        clockInOutPayload,
        loginData?.accessToken
      );

      setSelectedClokInJob((prevData) => {
        const allClockInZero = prevData.every((entry) => entry.clockInTime === "00:00");
        const updatedData = prevData.map((entry, i) => {
          if (i === index) {
            return {
              ...entry,
              clockInTime: updatedClockIn,
              clockOutTime: updatedClockOut,
              hours: calculateHoursBetween(updatedClockIn, updatedClockOut)
            };
          }
          if (typeof prevIndex === "number" && i === prevIndex) {
            return {
              ...entry,
              clockOutTime: now,
              hours: calculateHoursBetween(entry.clockInTime, now)
            };
          }
          return entry;
        });

        if (allClockInZero) {
          const updatedItem = updatedData[index];
          updatedData?.splice(index, 1);
          updatedData.unshift(updatedItem);
        }

        // Calculate total time for all jobs with valid clockIn/clockOut
        const totalMinutes = updatedData.reduce((sum, entry) => {
          if (
            entry.clockInTime &&
            entry.clockOutTime &&
            entry.clockInTime !== "00:00" &&
            entry.clockOutTime !== "00:00"
          ) {
            const [startH, startM] = entry.clockInTime.split(":").map(Number);
            const [endH, endM] = entry.clockOutTime.split(":").map(Number);
            let start = startH * 60 + startM;
            let end = endH * 60 + endM;
            if (end < start) end += 24 * 60;
            return sum + (end - start);
          }
          return sum;
        }, 0);

        const totalHours = Math.floor(totalMinutes / 60);
        const totalMins = totalMinutes % 60;
        const totalTimeStr = `${totalHours.toString().padStart(2, "0")}:${totalMins
          .toString()
          .padStart(2, "0")}`;
        setTotalTimeForClock(totalTimeStr ? totalTimeStr : "00:00");

        return updatedData;
      });
    } catch (error) {
      console.log("Error :: updateClockInAndClockOutTime ::", error);
      dispatch(
        setShowalert({ showAlert: true, title: "", text: error?.message || "Clock-in/out failed." })
      );
    } finally {
      setIsSavingClockIN(false);
    }
  };

  const handleClockIn = (parentIndex) => {
    const item = selectedClockInJob[parentIndex];
    const activeIndex = selectedClockInJob.findIndex(
      (j, idx) =>
        idx !== parentIndex && j.clockInTime && (!j.clockOutTime || j.clockOutTime === "00:00")
    );
    if (activeIndex !== -1) {
      setConfirmSwitchClock({
        show: true,
        newIndex: parentIndex,
        prevIndex: activeIndex
      });
    } else {
      updateClockInAndClockOutTime(item, parentIndex, "in");
    }
  };

  const handleClockOut = (parentIndex) => {
    const item = selectedClockInJob[parentIndex];
    updateClockInAndClockOutTime(item, parentIndex, "out");
  };

  const handleConfirmSwitchClock = () => {
    if (confirmSwitchClock.newIndex !== null && confirmSwitchClock.prevIndex !== null) {
      const item = selectedClockInJob[confirmSwitchClock.newIndex];
      updateClockInAndClockOutTime(
        item,
        confirmSwitchClock.newIndex,
        "in",
        confirmSwitchClock.prevIndex
      );
    }
    setConfirmSwitchClock({ show: false, newIndex: null, prevIndex: null });
  };

  const handleCancelSwitchClock = () => {
    setConfirmSwitchClock({ show: false, newIndex: null, prevIndex: null });
  };

  const deleteTimeSheetGoal = (entiresDataIndex, goalIndex) => {
    const deletedGoal = selectedClockInJob[entiresDataIndex]?.timesheetGoalsArray.filter(
      (v, i) => i === goalIndex
    );
    setDeletedGoalsCategories([...deletedGoalsCategories, deletedGoal[0]]);
    const remaningGoalData = selectedClockInJob[entiresDataIndex]?.timesheetGoalsArray.filter(
      (v, i) => i !== goalIndex
    );
    let data = [...selectedClockInJob];
    data[entiresDataIndex].timesheetGoalsArray = remaningGoalData ?? [];
    setSelectedClokInJob(data);
  };

  const handleRowClick = (value) => {
    let data = [...selectedClockInJob];
    data[value.itemIndex].isJobItemAddGoalClicked = false;
    setGoalIndex(value?.goalIndex);
    setIndexForGoal(value?.itemIndex);
    setSelectedClokInJob(data);
    if (onGoalModalOpen) {
      onGoalModalOpen();
    }
  };

  const onAddGoalClick = async (item, indexForGoal, from) => {
    let data = [...selectedClockInJob];

    data[indexForGoal] = {
      ...data[indexForGoal],
      isJobItemAddGoalClicked: true,
      from: from
    };

    await setIndexForGoal(indexForGoal);
    await setSelectedClokInJob(data);
    if (onGoalModalOpen) {
      onGoalModalOpen();
    }
    return;
  };

  const handleCommentChange = (e, index) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    const updatedJobs = [...selectedClockInJob];
    updatedJobs[index].comments = inputValue;
    setSelectedClokInJob(updatedJobs);
  };

  // ✅ FIXED: Updated handleDeleteClick with proper loading state
  const handleDeleteClick = async () => {
    try {
      setIsDeleting(true); // ✅ SET DELETE LOADING

      const deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: seletetdClockInTimesheet?.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      const response = await Postrequestcall(DELETE_TIMESHEETS, deleteObj, loginData?.accessToken);

      if (response?.success || response?.status === 201) {
        if (onDeleteComplete) {
          await onDeleteComplete(seletetdClockInTimesheet);
        } else if (onSaveComplete) {
          await onSaveComplete();
        }
        TimesheetClockInclose();
      } else {
        console.error("Failed to delete timesheet:", response);
        alert("Failed to delete timesheet. Please try again.");
      }
    } catch (error) {
      console.error("Error in handleDeleteClick:", error);
      alert("Something went wrong while deleting the timesheet.");
    } finally {
      setIsDeleting(false); // ✅ CLEAR DELETE LOADING
    }
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.siteCity,
      country: params?.siteCountry,
      province: params?.siteProvince,
      postalCode: params?.sitePostalCode,
      address: params?.siteAddress
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const handleShowAlert = () => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: TEXT_GOAL_CREDIT_WARNING
    };
    dispatch(setShowalert(alertObj));
  };

  return (
    <>
      <Modal open={open} onClose={TimesheetClockInclose}>
        <Box className="user-modal-responsive">
          <Stack sx={{ alignItems: { xs: "flex-start", sm: "center", justifyContent: "space-between" }} } direction={{ xs: "column", sm: "row" }}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={{ xs: "100%", sm: "40%" }}>
              <Typography sx={{ fontWeight: "bold" }} variant="h6">
                {operation === "edit" ? TEXT_EDIT_CLOCKIN : TEXT_ADD_CLOCKIN}
              </Typography>

              <Stack sx={{ display: { xs: "flex", sm: "none"  }}} direction={"row"}>
                <IconButton
                  size="small"
                  onClick={TimesheetClockInclose}
                  disabled={isAnyOperationInProgress}>
                  <CloseIcon />
                </IconButton>

                {/* ✅ FIXED: Save button with proper loading state */}
                <IconButton
                  onClick={onSaveTimesheet}
                  color="primary"
                  disabled={
                    selectedClockInJob?.length === 0 ||
                    selectedClockInJob?.some(
                      (job) =>
                        !job.clockInTime ||
                        !job.clockOutTime ||
                        job.clockInTime === "00:00" ||
                        job.clockOutTime === "00:00"
                    ) ||
                    isAnyOperationInProgress
                  }>
                  {isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                </IconButton>

                {/* ✅ FIXED: Delete button with proper loading state */}
                {operation !== "add" && (
                  <IconButton
                    onClick={() => setOpenDeleteConfirm(true)}
                    color="secondary"
                    disabled={isAnyOperationInProgress}>
                    {isDeleting ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
                  </IconButton>
                )}
              </Stack>
            </Stack>

            <Stack direction={"row"} sx={{ alignItems: "center" }}>
              <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction={"row"} spacing={1}>
                <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {TEXT_TOTAL_CAPS}:{" "}
                    {totalTimeForClock === 0 ||
                    totalTimeForClock === null ||
                    totalTimeForClock === undefined
                      ? "00:00"
                      : totalTimeForClock}
                  </Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {totalDistanceForClockIn === 0 ||
                    totalDistanceForClockIn === null ||
                    totalDistanceForClockIn === undefined ||
                    (Array.isArray(totalDistanceForClockIn) &&
                      totalDistanceForClockIn?.length === 0)
                      ? 0
                      : totalDistanceForClockIn}
                  </Typography>

                  <FormControl size="small">
                    <Select
                      value={roleIndex}
                      onChange={(e) => {
                        const value = e.target.value;

                        // ✅ FIXED: Update all job distance units and sync header
                        const data = [...selectedJob];
                        for (let i = 0; i < data?.length; i++) {
                          data[i].unitOfDistance = value === 1 ? "km" : "mi";
                        }
                        setSelectedJob(data);
                        setRoleIndex(value);
                      }}
                      displayEmpty
                      disabled={isAnyOperationInProgress}
                      inputProps={{ "aria-label": "Without label" }}>
                      {labelArray.map((v, i) => (
                        <MenuItem key={i} value={v.key}>
                          {v.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                {/* ✅ FIXED: Desktop buttons with proper loading states */}
                <Stack sx={{ display: { xs: "none", sm: "flex", alignItems: "center" }} } direction={"row"}>
                  <IconButton
                    size="small"
                    onClick={TimesheetClockInclose}
                    disabled={isAnyOperationInProgress}>
                    <CloseIcon />
                  </IconButton>

                  <IconButton
                    color="primary"
                    onClick={onSaveTimesheet}
                    disabled={
                      selectedClockInJob?.length === 0 ||
                      selectedClockInJob?.some(
                        (job) =>
                          !job.clockInTime ||
                          !job.clockOutTime ||
                          job.clockInTime === "00:00" ||
                          job.clockOutTime === "00:00"
                      ) ||
                      isAnyOperationInProgress
                    }>
                    {isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                  </IconButton>

                  {operation !== "add" && (
                    <IconButton
                      onClick={() => setOpenDeleteConfirm(true)}
                      color="secondary"
                      disabled={isAnyOperationInProgress}>
                      {isDeleting ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
                    </IconButton>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack sx={{ gap: 1.5,  marginTop: 2  }} >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                enableAccessibleFieldDOMStructure={false}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    disabled: true
                  }
                }}
                format="MMM DD, YYYY"
                value={
                  selectedClockInJob?.[0]?.timesheetDate
                    ? dayjs(selectedClockInJob[0].timesheetDate)
                    : dayjs()
                }
                className="timesheet-picker"
                label={TEXT_TIMESHEET_DATE}
                disabled
              />
            </LocalizationProvider>

            {loading ? (
              <Box sx={{ py: 4,  alignItems: "center",  justifyContent: "center",  display: "flex" }}   width="100%" >
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ height: "320px", overflow: "auto", scrollbarWidth: "none" }}>
                <Stack spacing={1.5}>
                  {selectedClockInJob?.length === 0 ? (
                    <div className="add-clock-job-modal-body">
                      <BusinessCenterIcon className="add-clock-job-modal-body-icon" />
                      <Typography variant="body2" sx={{ color: "gray", textAlign: "center" }}>
                        {TEXT_JOB_START}
                      </Typography>
                    </div>
                  ) : (
                    selectedClockInJob?.map((item, index) => (
                      <Card key={index} className="pagelist-content" sx={{ p: 2, mt: 0 }}>
                        <Typography variant="h6">
                          {item?.companyId === 0 || item?.companyName === ""
                            ? TEXT_NO_COMPANY
                            : item.companyName}
                        </Typography>

                        <CardHeader
                          action={
                            <IconButton
                              size="medium"
                              aria-label="settings"
                              onClick={() => removeCurrentTimesheet(item, index)}
                              disabled={isAnyOperationInProgress}>
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          }
                          sx={{ p: 0, pt: 1 }}
                          title={
                            <ListItem disablePadding alignItems="flex-start">
                              <Avatar
                                className="add-Timesheet-picture"
                                variant="square"
                                alt="contact-PictureUrl"
                                src={item?.mainPictureUrl || PlaceholderImg}
                              />
                              <ListItemText
                                sx={{ pl: 2, mt: 0 }}
                                primary={
                                  <Typography variant="body1" maxWidth={"430px"} noWrap>
                                    {item?.projectName}
                                  </Typography>
                                }
                                secondary={
                                  <Box>
                                    <Typography variant="body2" maxWidth={"430px"} noWrap>
                                      {item?.siteName}
                                    </Typography>
                                    <Typography variant="body2" maxWidth={"430px"} noWrap>
                                      {getAddress(item)}
                                    </Typography>
                                  </Box>
                                }
                              />
                            </ListItem>
                          }
                        />

                        <Grid sx={{ pt: 2 }} container spacing={1} size={12}>
                          <Grid size={11}>
                            <Stack direction="row" sx={{ alignItems: "center" }} spacing={1.5}>
                              <Stack direction="column" spacing={1} width={"120px"}>
                                <Typography>{TEXT_IN}</Typography>
                                {!item.clockInTime || item.clockInTime === "00:00" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleClockIn(index)}
                                    disabled={isAnyOperationInProgress}>
                                    {isSavingClock ? (
                                      <CircularProgress size={20} color="inherit" />
                                    ) : (
                                      TEXT_CLOCK_IN
                                    )}
                                  </Button>
                                ) : (
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    value={item.clockInTime}
                                    disabled
                                  />
                                )}
                              </Stack>
                              <Stack direction="column" spacing={1} width={"120px"}>
                                <Typography>{TEXT_OUT}</Typography>
                                {!item.clockOutTime || item.clockOutTime === "00:00" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleClockOut(index)}
                                    disabled={
                                      !item?.clockInTime ||
                                      item.clockInTime === "00:00" ||
                                      isAnyOperationInProgress
                                    }>
                                    {isSavingClock ? (
                                      <CircularProgress size={20} color="inherit" />
                                    ) : (
                                      TEXT_CLOCK_OUT
                                    )}
                                  </Button>
                                ) : (
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    value={item.clockOutTime}
                                    disabled
                                  />
                                )}
                              </Stack>

                              <Stack direction="column" spacing={1} width={"120px"}>
                                <Typography>{TEXT_MILAGE}</Typography>
                                <TextField
                                  size="small"
                                  type="number"
                                  placeholder="0"
                                  value={item.distance || ""}
                                  disabled={isAnyOperationInProgress}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    const inputValue = e.target.value;
                                    if (inputValue.length > 4) return;

                                    if (inputValue === "" || /^\d+$/.test(inputValue)) {
                                      const updatedJobs = [...selectedClockInJob];
                                      updatedJobs[index].distance = inputValue;
                                      setSelectedClokInJob(updatedJobs);

                                      const totalDistance = updatedJobs.reduce(
                                        (sum, job) =>
                                          Number(job.distance) > 0
                                            ? sum + Number(job.distance)
                                            : sum,
                                        0
                                      );
                                      setTotalDistanceForClockIn(totalDistance);
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: 4
                                  }}
                                />
                              </Stack>

                              <Stack direction="column" spacing={1}>
                                <Typography>{""}</Typography>
                                <Typography variant="body1">
                                  {roleIndex === 1 ? TEXT_KM : TEXT_MI}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Grid>

                          <Grid size={1}>
                            <Stack sx={{ display: "flex", justifyContent: "center" }}>
                              <IconButton
                                onClick={() => openImage(index)}
                                disabled={isAnyOperationInProgress}>
                                {item?.isShowimage ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                              </IconButton>
                            </Stack>
                          </Grid>
                        </Grid>

                        {item?.isShowimage && (
                          <Stack spacing={1.5} sx={{ pt: 1.5 }}>
                            {item?.timesheetGoalsArray?.map((goalItem, goalIndex) => (
                              <Stack sx={{ alignItems: "center", margin: "5px 0" }} key={goalIndex} direction="row" spacing={2}>
                                <IconButton
                                  color="secondary"
                                  onClick={() => {
                                    deleteTimeSheetGoal(indexForGoal, goalIndex);
                                  }}
                                  disabled={isAnyOperationInProgress}>
                                  <DoNotDisturbOnIcon />
                                </IconButton>
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  sx={{
                                    borderRadius: "5px",
                                    border: "1px solid",
                                    borderColor: "lightgray",
                                    padding: "15px",
                                    cursor: "pointer",
                                    width: "100%",
                                    justifyContent: "space-between"
                                  }}
                                  onClick={() =>
                                    handleRowClick({
                                      goalItem: goalItem,
                                      goalIndex: goalIndex,
                                      itemIndex: indexForGoal,
                                      item: item
                                    })
                                  }>
                                  <Typography>
                                    {goalItem?.goalName || goalItem?.categoryName}
                                  </Typography>
                                  <ArrowDropDownIcon />
                                </Stack>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <MobileTimePicker
                                    format="HH:mm"
                                    value={
                                      goalItem?.time === 0
                                        ? dayjs("00:00", "HH:mm")
                                        : dayjs(formatNumericToTime(goalItem?.time), "HH:mm")
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        const updatedJobs = [...selectedClockInJob];
                                        const decimalTime = convertToDecimal(
                                          newValue.format("HH:mm")
                                        );
                                        updatedJobs[indexForGoal].timesheetGoalsArray[
                                          goalIndex
                                        ].time = decimalTime;
                                        setSelectedClokInJob(updatedJobs);
                                      }
                                    }}
                                    disabled={isAnyOperationInProgress}
                                    ampm={false}
                                    renderInput={(params) => (
                                      <TextField
                                        size="small"
                                        {...params}
                                        sx={{
                                          width: "120px",
                                          marginLeft: 2,
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px"
                                          }
                                        }}
                                        disabled={isAnyOperationInProgress}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            ))}

                            {goallist?.length > 0 && (
                              <Stack direction="row" sx={{ marginTop: 2,  alignItems: "center" }} spacing={2} >
                                <Button
                                  startIcon={<AddIcon />}
                                  variant="contained"
                                  size="small"
                                  disabled={isAnyOperationInProgress}
                                  onClick={() => {
                                    onAddGoalClick(item, indexForGoal, "clockin");
                                  }}>
                                  {TEXT_ADD_GOAL}
                                </Button>
                                <IconButton
                                  onClick={() => handleShowAlert()}
                                  disabled={isAnyOperationInProgress}>
                                  <HelpIcon />
                                </IconButton>
                              </Stack>
                            )}

                            <TextField
                              label={TEXT_COMMENTS_PLACEHOLDER}
                              multiline
                              rows={2}
                              fullWidth
                              value={item?.comments || ""}
                              disabled={isAnyOperationInProgress}
                              onChange={(e) => handleCommentChange(e, index)}
                            />

                            {item?.pictureList?.length !== 0 ? (
                              <>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Grid container spacing={1} sx={{ alignItems: "center" }}>
                                    <Grid
                                      size={{ xs: 4, sm: 3, md: 3 }}
                                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                                      <Button
                                        sx={{
                                          width: "100%",
                                          height: "100%",
                                          color: "GrayText",
                                          borderRadius: "10px",
                                          backgroundColor: "lightgray",
                                          boxShadow: "none",
                                          textAlign: "center",
                                          p: 0
                                        }}
                                        variant="text"
                                        size="small"
                                        component="label"
                                        disabled={isAnyOperationInProgress}>
                                        <ImageIcon /> {TEXT_ADD_PICTURES}
                                        <input
                                          id="timeSheetPicture-upload"
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          onChange={(e) => handleChooseFile(e, index)}
                                          hidden
                                          disabled={isAnyOperationInProgress}
                                        />
                                      </Button>
                                    </Grid>

                                    <Grid
                                      size={{ xs: 8, sm: 9, md: 9 }}
                                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                                      <ImageList
                                        gap={7.5}
                                        sx={{
                                          width: "100%",
                                          height: "100%",
                                          margin: 0,
                                          padding: 0,
                                          flexWrap: "nowrap",
                                          overflowX: "auto",
                                          display: "flex",
                                          scrollbarWidth: "none",
                                          borderRadius: "10px",
                                          backgroundColor: "white"
                                        }}>
                                        {item?.pictureList.map((picItem, picIndex) => (
                                          <ImageListItem
                                            key={picIndex}
                                            sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                                            <img
                                              src={
                                                picItem?.url
                                                  ? picItem?.url
                                                  : typeof picItem?.pictureUrl === "string"
                                                    ? picItem.pictureUrl
                                                    : picItem?.pictureUrl instanceof File
                                                      ? URL.createObjectURL(picItem.pictureUrl)
                                                      : ""
                                              }
                                              style={{
                                                borderRadius: 10,
                                                width: isSmallScreen ? 90 : 130,
                                                height: isSmallScreen ? 90 : 130,
                                                objectFit: "cover"
                                              }}
                                              alt="Expenses"
                                              loading="lazy"
                                            />
                                            <ImageListItemBar
                                              sx={{ background: "none", padding: 1 }}
                                              position="top"
                                              actionIcon={
                                                <IconButton
                                                  onClick={() =>
                                                    onDeletePicturePressed(picItem, picIndex, index)
                                                  }
                                                  size="small"
                                                  disabled={isAnyOperationInProgress}
                                                  sx={{
                                                    color: "white",
                                                    backgroundColor: "rgba(0,0,0,0.3)"
                                                  }}>
                                                  <CloseIcon fontSize="small" />
                                                </IconButton>
                                              }
                                              actionPosition="right"
                                            />
                                          </ImageListItem>
                                        ))}
                                      </ImageList>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </>
                            ) : (
                              <Button
                                sx={{
                                  width: "100%",
                                  color: "GrayText",
                                  height: 100,
                                  backgroundColor: "lightgray",
                                  boxShadow: "none"
                                }}
                                startIcon={<ImageIcon />}
                                variant="contained"
                                size="small"
                                component="label"
                                disabled={isAnyOperationInProgress}>
                                {TEXT_ADD_PICTURES}
                                <input
                                  id="timeSheetPicture-upload"
                                  type="file"
                                  multiple
                                  accept="image/*"
                                  onChange={(e) => handleChooseFile(e, index)}
                                  hidden
                                  disabled={isAnyOperationInProgress}
                                />
                              </Button>
                            )}
                          </Stack>
                        )}
                      </Card>
                    ))
                  )}
                </Stack>
              </Box>
            )}

            <Button
              onClick={onJoblistOpen}
              variant="contained"
              fullWidth
              size="medium"
              disabled={isAnyOperationInProgress}>
              {BUTTON_ADD_JOB}
            </Button>
          </Stack>
        </Box>
      </Modal>

      <PromptModal
        isOpen={confirmSwitchClock.show}
        onClose={handleCancelSwitchClock}
        title={"Switch Job?"}
        desc={"You have another job clocked in. Do you want to clock it out and clock in this job?"}
        redButtonText={"OK"}
        onRedButtonClick={handleConfirmSwitchClock}
      />

      <PromptModal
        isOpen={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
        title={TEXT_DELETE_TIMESHEET_TITLE}
        desc={TEXT_DELETE_TIMESHEET_DESCRIPTION}
        redButtonText={BUTTON_DELETE}
        onRedButtonClick={() => {
          handleDeleteClick();
          setOpenDeleteConfirm(false);
        }}
      />
    </>
  );
};

export default AddClockIn;

